import { useEffect, useState } from "react";
import axios from "axios";
import { set } from "lodash";

/**
 * Custom hook for saving chat sessions.
 * @returns An object containing the saved data, loading state, and a function to save session information.
 */
const useSaveFeedbackInfo = () => {
    const [data, setData] = useState<any>({});
    const [loading, setLoading] = useState(false);

    const API_URL = process.env.REACT_APP_SAVE_FEEDBACK || ""
    // const api_key = process.env.REACT_APP_API_KEY || "HTCHL77uXq2c9Fr99TgG211Cu6OL5FsLslnseNUj"
    /**
     * Saves the chat session information.
     * @param requestObject - The object containing the session information to be saved.
     */
    const saveFeedbackInfo = async (requestObject: any) => {
        console.log("requestObject", requestObject);
        try {
            setLoading(true);
            const responseFetch = await fetch(API_URL, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    // "x-api-key": api_key
                },
                body: JSON.stringify(requestObject),
            });
            const response = await responseFetch.json();

            setData(response);
        } catch (error) {
            setData(null);
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    return { data, loading, saveFeedbackInfo };
};

export default useSaveFeedbackInfo;